import styled from 'styled-components'

export const FormContainer = styled.div`
    @media (min-width: 992px) {
        width: 750px;
        width: 970px;
    }
    @media (min-width: 1600px) {
        width: 1170px;
    }
    padding: 20px;
`

export const NewGroupScreenContainer = styled.div`
    width: 100%;

    .new-group-body {
        width: 100%;
        overflow: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-wrap: wrap;
        height: calc(100vh - 120px);

        .body-form-group {
            display: flex;
            gap: 10%;
            font-size: 14px;
            font-weight: 600;
            padding: 24px 0 0;
            @media (min-width: 952px) {
                width: 710px;
                width: 930px;
            }
            @media (min-width: 1560px) {
                width: 1130px;
            }

            .label-input-bundle {
                display: flex;
                flex-direction: column;
                gap: 8px;
                width: 100%;
                input,
                textarea {
                    font-size: 16px;
                    font-weight: 400;
                }
            }
            .form-text-inputs {
                display: flex;
                flex-direction: column;
                gap: 24px;
                width: 100%;
                textarea {
                    height: 190px;
                }
            }

            .form-select {
                width: 100%;
                font-size: 16px;
                font-weight: 400;
                span {
                    font-size: 14px;
                    font-weight: 600;
                }
            }

            .list-user {
                display: flex;
                flex-direction: column;
                border: 1px solid ${({ theme }) => theme['gray-400']};
                margin-top: 8px;
                /* box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);     */
                border-radius: 2px;
                height: 225px;
                width: 100%;
                padding: 16px;
                gap: 8px;
                overflow-y: scroll;

                .name-user {
                    font-weight: 400;
                    font-size: 16px;
                    color: ${({ theme }) => theme['gray-700']};
                    line-height: 24px;
                    display: flex;
                    justify-content: space-between;
                    .fa-times-circle {
                        visibility: hidden;
                    }
                }

                .name-user:hover {
                    .fa-times-circle {
                        visibility: visible;
                        cursor: pointer;
                    }
                }
            }
        }
        .new-group-save {
            background-color: ${({ theme }) => theme['gray-200']};
            padding: 0 16px;
            font-size: 15px;
            display: flex;
            align-items: center;
            height: 64px;
            @media (min-width: 952px) {
                width: 710px;
                width: 930px;
            }
            @media (min-width: 1560px) {
                width: 1130px;
            }
            .button-cancel-save {
                color: ${({ theme }) => theme['blue-500']};
                font-weight: 600;
            }
            .label-save-bar {
                margin-right: 11px;
            }
            > button {
                font-size: 15px;
                font-weight: 600;
            }
        }

        .button-cancel-save {
            cursor: pointer;
        }
    }
`
